import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Button } from '../ui/button';
import {
  MoreHorizontal, Eye, Download, UserCheck, Mail, KeyRound,
  Shield, ShieldOff, Archive, Trash2, RotateCcw,
} from 'lucide-react';

export function UserActionsMenu({
  targetUser, currentUserId, activeTab,
  onViewAutomata, onExport, onImpersonate, onMessage,
  onResetPassword, onChangeRole, onArchive, onDelete, onRestore, onPermanentDelete,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-8 w-8" data-testid={`actions-btn-${targetUser.user_id}`}>
          <MoreHorizontal className="w-4 h-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onViewAutomata(targetUser)} data-testid={`view-automata-${targetUser.user_id}`}>
          <Eye className="w-4 h-4 mr-2" /> View Automata
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onExport(targetUser)} data-testid={`export-${targetUser.user_id}`}>
          <Download className="w-4 h-4 mr-2" /> Export Data
        </DropdownMenuItem>

        {activeTab === 'active' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onImpersonate(targetUser)} data-testid={`impersonate-${targetUser.user_id}`}>
              <UserCheck className="w-4 h-4 mr-2" /> View as User
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onMessage(targetUser)} data-testid={`message-${targetUser.user_id}`}>
              <Mail className="w-4 h-4 mr-2" /> Send Email
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onResetPassword(targetUser)} data-testid={`reset-pw-${targetUser.user_id}`}>
              <KeyRound className="w-4 h-4 mr-2" /> Reset Password
            </DropdownMenuItem>
            {targetUser.user_id !== currentUserId && (
              <DropdownMenuItem onClick={() => onChangeRole(targetUser)} data-testid={`change-role-${targetUser.user_id}`}>
                {targetUser.role === 'admin'
                  ? <><ShieldOff className="w-4 h-4 mr-2" /> Demote to User</>
                  : <><Shield className="w-4 h-4 mr-2" /> Promote to Admin</>}
              </DropdownMenuItem>
            )}
            {targetUser.user_id !== currentUserId && targetUser.role !== 'admin' && (
              <>
                <DropdownMenuSeparator />
                <DropdownMenuItem onClick={() => onArchive(targetUser)} data-testid={`archive-${targetUser.user_id}`}>
                  <Archive className="w-4 h-4 mr-2" /> Archive
                </DropdownMenuItem>
                <DropdownMenuItem
                  className="text-destructive focus:text-destructive"
                  onClick={() => onDelete(targetUser)}
                  data-testid={`delete-${targetUser.user_id}`}
                >
                  <Trash2 className="w-4 h-4 mr-2" /> Delete
                </DropdownMenuItem>
              </>
            )}
          </>
        )}

        {activeTab === 'archived' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onRestore(targetUser)} data-testid={`restore-${targetUser.user_id}`}>
              <RotateCcw className="w-4 h-4 mr-2" /> Restore
            </DropdownMenuItem>
            <DropdownMenuItem
              className="text-destructive focus:text-destructive"
              onClick={() => onDelete(targetUser)}
              data-testid={`delete-${targetUser.user_id}`}
            >
              <Trash2 className="w-4 h-4 mr-2" /> Delete
            </DropdownMenuItem>
          </>
        )}

        {activeTab === 'deleted' && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => onRestore(targetUser)} data-testid={`restore-${targetUser.user_id}`}>
              <RotateCcw className="w-4 h-4 mr-2" /> Restore
            </DropdownMenuItem>
            <DropdownMenuItem
              className="text-destructive focus:text-destructive"
              onClick={() => onPermanentDelete(targetUser)}
              data-testid={`perm-delete-${targetUser.user_id}`}
            >
              <Trash2 className="w-4 h-4 mr-2" /> Permanently Delete
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
